import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: '246412685',
  router
})

require("../public/fonts/Baewatch.eot");
require("../public/fonts/Baewatch.svg");
require("../public/fonts/Baewatch.eot?#iefix");
require("../public/fonts/Baewatch.otf");
require("../public/fonts/Baewatch.ttf");
require("../public/fonts/Baewatch.woff");
require("../public/fonts/Baewatch.woff2");


import '../public/fonts/webfont.css';
import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
